import { CustomTooltip } from '@components';
import { Box, Typography } from '@mui/material';
import { defaultTooltipStyle } from '@utils/styles';

export interface LabeledValueProp {
  label: string;
  value: string | number;
  formatValue?: (value: string | number) => string | number;
}

const LabeledValue = ({ label, value, formatValue }: LabeledValueProp) => {
  const formattedValue = formatValue ? formatValue(value) : value;
  const length = typeof formattedValue === 'string' ? formattedValue.length : 0;

  return (
    <Box
      sx={{
        maxWidth: '100%',
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Manrope, sans-serif',
          fontWeight: 700,
          fontSize: '0.75rem',
          color: '#6C6C6C',
          marginBottom: '0.25rem',
        }}
      >
        {label}
      </Typography>
      {length > 30 ? (
        <CustomTooltip
          customStyle={{
            '& .MuiTooltip-tooltip': { ...defaultTooltipStyle },
          }}
          content={formattedValue}
        >
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '1rem',
              color: '#162936',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              ':hover': {
                cursor: 'pointer',
              },
            }}
          >
            {(formattedValue as string).slice(0, 30) + '...'}
          </Typography>
        </CustomTooltip>
      ) : (
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '1rem',
            color: '#162936',
            lineHeight: '1.25rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            maxWidth: '100%',
          }}
        >
          {formattedValue}
        </Typography>
      )}
    </Box>
  );
};

export default LabeledValue;
